define('services/outbound/contactListService',[
    'jquery',
    'enums/outbound/ImportStates',
    'lib/bluebird',
    'lib/knockout',
    'lib/lodash4',
    'services/apiCore',
    'services/fileUploadService',
    'services/notificationService'
], function (
    $,
    IMPORT_STATES,
    Promise,
    ko,
    _,
    apiCore,
    fileUploadService,
    notificationService) {
    'use strict';

    var downloadNotifications = ko.observableArray([]);
    var promises = [];


    var uris = {
        CONTACTLISTS: '/outbound/contactlists',

        contactLists: function () {
            return uris.CONTACTLISTS;
        },
        contactList: function (id) {
            return uris.CONTACTLISTS + '/' + id;
        },
        contactListImportStatus: function (id) {
            return uris.CONTACTLISTS + '/' + id + '/importStatus';
        },
        download: function (id) {
            return uris.CONTACTLISTS + '/' + id + '/export';
        },
        contacts: function (id) {
            return uris.CONTACTLISTS + '/' + id + '/contacts';
        },
        contact: function (id, contactId) {
            return uris.CONTACTLISTS + '/' + id + '/contacts/' + contactId;
        },
        contactListProgress: function (id, idCampaign){
            return uris.CONTACTLISTS + '/' + id + '/' + idCampaign + '/' + 'penetrationrate';
        },
        upload: function () {
            return '/contactlist';
        }
    };


    var service = {
        getContactLists: function (options) {
            options = _.assign({ pageSize: 100, pageNumber: 1 }, options);

            var uri = uris.contactLists();
            return apiCore.get(uri, options);
        },
        getContactList: function (id) {
            var uri = uris.contactList(id);
            return apiCore.get(uri)
                .then(function (data) {
                    // TODO: May be able to remove this if/when the download uri is added to the actual model
                    var notification = _.find(service.downloadNotifications(), function(item) {
                        return item.associatedResource.id === data.id;
                    });
                    if (notification) {
                        data.downloadUri = notification.downloadUrl;
                    }
                    return Promise.resolve(data);
                });
        },
        getContactListImportStatus: function (id) {
            var uri = uris.contactListImportStatus(id);
            return apiCore.v2.get(uri);
        },
        downloadContactList: function (id) {
            var promiseResolver = Promise.defer();

            notificationService.subscribe('outbound.contactlists.' + id + '.export', downloadCallback);

            apiCore.post(uris.download(id))
                .catch(function (err) {
                    promiseResolver.reject(err);
                });

            promises.push({
                id: id,
                promise: promiseResolver
            });
            return promiseResolver.promise.cancellable();
        },
        createContactList: function (data) {
            //data must be a minimum of an object with a name property
            var uri = uris.contactLists();
            return apiCore.post(uri, data);
        },
        updateContactList: function (id, data) {
            var uri = uris.contactList(id);
            return apiCore.put(uri, data);
        },
        createContact: function (listId, data) {
            var uri = uris.contacts(listId);
            if(!_.isArray(data)) {
                data = [data];
            }
            return apiCore.post(uri, data);
        },
        updateContact: function (contactId, listId, data) {
            var uri = uris.contact(listId, contactId);
            return apiCore.put(uri, data);
        },
        deleteContactList: function (uri) {
            return apiCore.del(uri);
        },
        uploadContactList: function (id, file) {
            var uri = uris.upload();
            var metadata = {
                'fileType': 'contactlist',
                'id': id
            };
            return fileUploadService.upload(uri, file, metadata);
        },
        downloadNotifications: downloadNotifications,
        getImportStates: function () {
            return IMPORT_STATES;
        },
        importStatus: {
            isInProgress: function(importStatus) {
                return !_.isUndefined(importStatus) &&
                       importStatus.state === IMPORT_STATES.IN_PROGRESS;
            },
            hasFailed: function(importStatus) {
                return !_.isUndefined(importStatus) &&
                       importStatus.state === IMPORT_STATES.FAILED;
            },
            isComplete: function(importStatus) {
                //an undefined importStatus signals a completed import
                return _.isUndefined(importStatus) ||
                       !service.importStatus.isInProgress(importStatus) &&
                       !service.importStatus.hasFailed(importStatus);
            }
        },
        getProgress: function (idContactList, idCampaign) {
            var uri = uris.contactListProgress(idContactList, idCampaign);
            return apiCore.get(uri);
        }
    };


    var downloadCallback = function (data) {
        // remove any previous download links for this contact list
        var notification = _.find(service.downloadNotifications(), function(item) {
            return item.associatedResource.id === data.associatedResource.id;
        });
        if (notification) {
            service.downloadNotifications.remove(notification);
        }

        // resolve any outstanding promises
        var listPromise = _.find(promises, { id: data.associatedResource.id });
        if (listPromise) {
            listPromise.promise.resolve(data);
            promises = _.without(promises, listPromise);
        }

        service.downloadNotifications.push(data);

        notificationService.unsubscribe('outbound.contactlists.' + data.associatedResource.id + '.export', downloadCallback);
    };

    return service;
});

